import React from 'react'

function Title() {
    return (
        <div class="Title">
            <h1>Web Request Data</h1>
        </div>
    )
}

export default Title